export type GradeGroup = '초등학생' | '중학생' | '고등학생' | '기타';

export const GRADE_GROUPS: GradeGroup[] = ['초등학생', '중학생', '고등학생'];

/** 학년 문자열을 초/중/고 그룹으로 분류해요. (예: '초3' → 초등학생) */
export function gradeGroupOf(grade?: string | null): GradeGroup {
  const g = (grade ?? '').trim();
  if (g.startsWith('초')) return '초등학생';
  if (g.startsWith('중')) return '중학생';
  if (g.startsWith('고')) return '고등학생';
  return '기타';
}